const features = [
  {
    icon: 'ri-global-line',
    title: '海量漫画资源',
    desc: '收录超过10万部韩漫、日漫、国漫作品，涵盖恋爱、奇幻、热血、悬疑等全品类题材，持续扩充中。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新同步',
    desc: '每日50+部漫画同步更新，热门连载第一时间上线，让你追更不落伍，永远走在漫画潮流最前沿。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝阅读',
    desc: '支持Web端、iOS、Android三端同步，阅读进度云同步，随时随地无缝切换设备继续阅读。',
  },
  {
    icon: 'ri-eye-2-line',
    title: '沉浸式阅读体验',
    desc: '高清画质搭配智能分页，支持横竖屏切换、夜间模式和自定义亮度，给你最舒适的漫画阅读感受。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '正版授权保障',
    desc: '所有漫画均获得正版授权或合规引进，尊重原创作者版权，让读者安心阅读每一部精彩作品。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            为什么选择蛙漫
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            五大优势，重新定义漫画阅读
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            从内容数量到阅读体验，蛙漫漫画在每一个细节为你精心打磨
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}